module.exports = __webpack_public_path__ + "media/images/line-4@1x-c180e87f77afbd021f2d3d9f8138441e.png";